import React, { useEffect, useState } from 'react';
import { landingPageRoute, setGoalPageRoute } from '../../common/linkRoutes';
import {
  ASSIGNED,
  BEHIND,
  COMPLETED,
  ON_PROGRESS,
  PLANNED,
} from '../../common/Types';
import Layout from '../../components/layout/Layout';
import { useStore } from '../../store/store';
import { BasicProps } from './GoalPage';
import { useListVals } from 'react-firebase-hooks/database';
import { goalRef } from '../../firebase/refs';
import GoalTask from '../../components/task/GoalTask';
import { GoalI } from '../../interfaces/GoalInterface';

const GoalsPage = (props: BasicProps) => {
  const { setRedirect, user } = useStore();

  const [goalList] = useListVals<any>(goalRef);

  const [filteredList, setFilteredList] = useState<GoalI[]>([]);

  useEffect(() => {
    if (!user || !goalList || !goalList.length) return;
    var _isSubscribe = true;

    const allGoals =
      goalList
        .filter((_g) => _g.user_uid === user.uid)
        .sort((a, b) => b.priority - a.priority) || [];

    if (_isSubscribe) {
      setFilteredList(allGoals);
    }

    return () => {
      goalRef.off();
      _isSubscribe = false;
    };
  }, [goalList, user]);

  return (
    <Layout pageName="Goals" backRoute={landingPageRoute} {...props}>
      {/* CREATE GOAL BUTTON */}
      <button
        onClick={() => setRedirect(setGoalPageRoute)}
        className="btn bg-black"
      >
        Set Goal<span>→</span>
      </button>

      {renderGoalListByStatus(BEHIND, filteredList)}
      {renderGoalListByStatus(ON_PROGRESS, filteredList)}
      {renderGoalListByStatus(PLANNED, filteredList)}
      {renderGoalListByStatus(ASSIGNED, filteredList)}
      {renderGoalListByStatus(COMPLETED, filteredList)}
    </Layout>
  );

  function renderGoalListByStatus(status: string, allGoals: GoalI[]) {
    const _goalList = allGoals.filter((_t) => _t.goalStatus === status);
    // .slice(0, 2);

    if (!_goalList.length) {
      return <></>;
    }

    return (
      <div style={{ marginTop: '0.5rem', width: '100%' }}>
        <h2 style={{ textAlign: 'left' }}>{status}</h2>
        {React.Children.toArray(
          _goalList.map((_g) => <GoalTask data={_g} {...props} />)
        )}
      </div>
    );
  }
};

export default GoalsPage;
